import { useMemo } from "react";

export const usePageTitle = () => {
  const pageTitle = useMemo(() => document?.title, []);
  return { pageTitle };
};
